import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import api from '../services/api';
import Logo from '../components/Logo';
import { FOCO } from '../utils/a11y';

export default function Login() {
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [mostrarPass, setMostrarPass] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totpRequerido, setTotpRequerido] = useState(false);
  const [reenvio, setReenvio] = useState('');
  const { login, error, verificacionPendiente } = useAuthStore();

  const reenviarVerificacion = async () => {
    setReenvio('enviando');
    try {
      const res = await api.post('/reenviar-verificacion', { usuario });
      setReenvio(res.data?.message || 'Te enviamos un nuevo enlace.');
    } catch {
      setReenvio('No se pudo enviar. Intenta en unos minutos.');
    }
  };
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const result = await login(usuario, contrasena, totpRequerido ? totpCode : undefined);
    if (result === 'totp_requerido') {
      setTotpRequerido(true);
    } else if (result === true) {
      navigate('/dashboard');
    }

    setIsLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-slate-900 dark:to-slate-800">
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
        <div className="text-center mb-8">
          <h1 className="flex justify-center mb-3"><Logo iconClassName="h-12 w-12" textClassName="text-3xl" /></h1>
          <p className="text-gray-600 dark:text-gray-400">Panel de Control Financiero</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="bg-red-100 dark:bg-red-900 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-200 px-4 py-3 rounded">
              {error}
              {verificacionPendiente && (
                <div className="mt-2">
                  {reenvio && reenvio !== 'enviando'
                    ? <span className="text-sm">{reenvio}</span>
                    : <button type="button" onClick={reenviarVerificacion} disabled={reenvio === 'enviando'}
                        className="min-h-[44px] text-sm font-semibold underline hover:no-underline">
                        {reenvio === 'enviando' ? 'Enviando...' : 'Reenviar enlace de verificación'}
                      </button>}
                </div>
              )}
            </div>
          )}

          {!totpRequerido ? (
            <>
              <div>
                <label htmlFor="login-usuario" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Usuario</label>
                <input
                  id="login-usuario"
                  type="text"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value)}
                  className="w-full min-h-[44px] px-4 py-2 border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent dark:bg-slate-700 dark:text-white transition"
                  placeholder="Ingresa tu usuario"
                  disabled={isLoading}
                  autoComplete="username"
                />
              </div>
              <div>
                <label htmlFor="login-contrasena" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Contraseña</label>
                <div className="relative">
                  <input
                    id="login-contrasena"
                    type={mostrarPass ? 'text' : 'password'}
                    value={contrasena}
                    onChange={(e) => setContrasena(e.target.value)}
                    className="w-full min-h-[44px] px-4 py-2 pr-12 border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent dark:bg-slate-700 dark:text-white transition"
                    placeholder="Ingresa tu contraseña"
                    disabled={isLoading}
                    autoComplete="current-password"
                  />
                  <button type="button" onClick={() => setMostrarPass(v => !v)}
                    aria-label={mostrarPass ? 'Ocultar contraseña' : 'Mostrar contraseña'} aria-pressed={mostrarPass}
                    className={`absolute inset-y-0 right-0 flex items-center justify-center min-w-[44px] px-3 rounded-r-lg text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 ${FOCO}`}>
                    {mostrarPass
                      ? <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9-4-9-7s4-7 9-7a10.05 10.05 0 011.875.175M15 12a3 3 0 11-6 0 3 3 0 016 0zm5.121-5.121A9.956 9.956 0 0121 12c0 3-4 7-9 7a9.956 9.956 0 01-5.121-1.379M3 3l18 18" /></svg>
                      : <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div>
              <div className="text-center mb-4">
                <div className="text-3xl mb-2">🔐</div>
                <p className="text-gray-700 dark:text-gray-300 font-medium">Verificación en dos pasos</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Ingresa el código de tu aplicación autenticadora</p>
              </div>
              <label htmlFor="login-totp" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Código de 6 dígitos</label>
              <input
                id="login-totp"
                type="text"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                value={totpCode}
                onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, ''))}
                className="w-full px-4 py-3 text-center text-2xl tracking-widest border border-gray-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent dark:bg-slate-700 dark:text-white transition"
                placeholder="000000"
                disabled={isLoading}
                autoFocus
              />
              <button type="button" onClick={() => setTotpRequerido(false)} className="mt-2 min-h-[44px] text-sm text-blue-600 dark:text-blue-400 hover:underline">
                ← Volver
              </button>
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading || (totpRequerido && totpCode.length !== 6)}
            className="w-full min-h-[44px] bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-bold py-2 px-4 rounded-lg transition duration-200"
          >
            {isLoading ? 'Verificando...' : totpRequerido ? 'Verificar código' : 'Iniciar sesión'}
          </button>
        </form>

        <div className="mt-6 space-y-2 text-center text-sm">
          <div>
            <Link to="/recuperar" className="inline-flex items-center min-h-[44px] text-blue-600 dark:text-blue-400 hover:underline">
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
          <div className="text-gray-500 dark:text-gray-400">
            ¿No tienes cuenta?{' '}
            <Link to="/registro" className="inline-flex items-center min-h-[44px] text-blue-600 dark:text-blue-400 font-semibold hover:underline">
              Crear cuenta gratis
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
